import { AddressFields } from './address-fields';

import { useFormDefinition } from '../hooks/use-form';
import { addressQueryToFormValue, showFieldsAsInputs } from '../shared';
import type { AddressPreviewProps } from '../types';

export function AddressPreview({ value: parentAddressValue }: AddressPreviewProps) {
  const parentFormValue = addressQueryToFormValue(parentAddressValue);

  const form = useFormDefinition(parentFormValue);

  const [country, city, state, is_valid_postal_code] = form.watch(['country', 'city', 'state', 'is_valid_postal_code']);

  return (
    <AddressFields
      form={form}
      isEdit={false}
      cityOptions={city?.value ? [city] : []}
      stateOptions={state?.id ? [state] : []}
      countriesOptions={country?.name ? [country] : []}
      showRegion={showFieldsAsInputs({ is_valid_postal_code, country })}
      showCityAsInput={showFieldsAsInputs({ is_valid_postal_code, country })}
    />
  );
}
